import { bl_inv_stock_replenishment_run_doc_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentRunDocLinkModel extends BaseContainerModel {
    bl_inv_stock_replenishment_run_doc_link: bl_inv_stock_replenishment_run_doc_link_RowClass = new bl_inv_stock_replenishment_run_doc_link_RowClass();
}
